<template>
    <div class="mine">
        <!-- 标题栏 -->
        <van-nav-bar title="个人中心" />
        <div class="page">
            <div class="u-info">
                <img src="img/user/user/img_bg.png" class="bg" />
                <div class="kqb-card disp-flex userCardBG">
                    <div class="kqb-Avatar">
                        <img v-lazy="personInfo.personAccountInfoHeadImg" />
                    </div>
                    <div class="user-info tl">
                        <div class="userName" v-if="!isLogin">未登录</div>
                        <div class="userName" v-else>
                            <button style="background-color: transparent;">
                                {{ personInfo.personAccountInfoNickName }}
                            </button>
                        </div>
                        <div
                            class="fc-686D74"
                            style="width:60%;"
                            v-if="personInfo.personIsVip == 1"
                        >
                            VIP
                        </div>
                        <div
                            class="fc-686D74 navigator-arrow"
                            v-if="false"
                            @click="pageJump"
                            :data-uri="'/personalInformation'"
                        >
                            查看个人资料
                        </div>
                        <div class="level" v-if="personInfo.personIsVip == 1">
                            VIP
                        </div>
                        <div class="level" v-if="personInfo.personIsVip == 1">
                            尊贵会员
                        </div>
                    </div>
                </div>
            </div>
            <div class="kqb-list">
                <div
                    class="kqb-list-item navigator-arrow"
                    @click="showModal = true"
                >
                    <img
                        class="kqb-list-item-icon"
                        src="img/user/user/icon_activity.png"
                    />
                    <div class="tl">
                        <div>激活码申请</div>
                        <div class="fc-8F8F8F">申请激活码，激活VIP权限</div>
                    </div>
                </div>
                <div
                    class="kqb-list-item navigator-arrow"
                    @click="pageJump"
                    :data-uri="'/vipPrivilege'" v-if="personInfo.personIsVip == 1"
                >
                    <img
                        class="kqb-list-item-icon"
                        src="img/user/user/icon_activity.png"
                    />
                    <div>成为VIP</div>
                </div>
                <div
                    class="kqb-list-item navigator-arrow"
                    @click="pageJump"
                    :data-uri="'/helpCenter'"
                >
                    <img
                        class="kqb-list-item-icon"
                        src="img/user/user/icon_help.png"
                    />
                    <div>帮助中心</div>
                </div>
            </div>
            <!-- 申请激活码 -->
            <div class="kqb-modal" v-if="showModal">
                <div class="kqb-modal-content">
                    <img class="modal-head-bg" src="img/modal_hd_bg.png" />
                    <div class="kqb-form-list">
                        <input
                            type="text"
                            placeholder="姓名"
                            placeholder-class="placeholder"
                            v-model="personName"
                        />
                        <input
                            maxlength="11"
                            type="text"
                            placeholder="手机号"
                            placeholder-class="placeholder"
                            v-model="personMobileNo"
                        />
                        <button
                            class="kqb-btn kqb-btn-block bgC-F98E70"
                            @click="submitApplyActivationCode"
                        >
                            提交申请
                        </button>
                    </div>
                    <img
                        class="modal-close"
                        src="img/user/user/icon_close.png"
                        @click.stop="showModal = false"
                    />
                </div>
            </div>
        </div>
        <!-- 底部navbar -->
        <van-tabbar
            v-model="active"
            active-color="#4A4846"
            inactive-color="#9C9B9B"
        >
            <van-tabbar-item
                :name="item.name"
                @click="switchTab(item)"
                v-for="(item, index) in navbars"
                :key="index"
            >
                <span v-text="item.text" style="font-size:14px"></span>
                <img
                    slot="icon"
                    slot-scope="props"
                    :src="props.active ? item.active : item.normal"
                />
            </van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
  name: 'mine',
  data () {
    return {
      active: 2,
      navbars: [
        {
          text: 'VIP区',
          normal: './img/common/tabs/tab1.png',
          active: './img/common/tabs/tab1_HL.png'
        }, {
          text: '专辑区',
          normal: './img/common/tabs/tab2.png',
          active: './img/common/tabs/tab2_HL.png'
        },
        {
          text: '我的',
          normal: './img/common/tabs/tab3.png',
          active: './img/common/tabs/tab3_HL.png'
        }
      ],
      personInfo: {},
      isLogin: false,
      showModal: false,
      personName: '',
      personMobileNo: ''
    }
  },
  created () {
    const thisObj = this
    thisObj.getData()
  },
  methods: {
    switchTab (item) {
      const thisObj = this
      let router = ''
      switch (item.text) {
        case 'VIP区':
          router = '/'
          break
        case '专辑区':
          // router = '/alliance'
          thisObj.$util.requetServerError('升级中,即将上线')
          break
        default:
          router = '/user'
      }
      if (item.text === '专辑区') { return }
      thisObj.$router.push(router)
    },
    getData () {
      var that = this
      that.personInfo = this.$root.userInfo
      that.isLogin = true
    },
    pageJump (e) {
      const thisObj = this
      let uri = e.target.dataset.uri
      let queryData = {}
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    submitApplyActivationCode () {
      var that = this
      var person = this.$root.userInfo
      var personName = this.personName
      var personMobileNo = this.personMobileNo
      var url = that.requestUrl + '/auth/person/info/activation/code/apply/add?fromDevice=h5&personName=' + personName + '&personMobileNo=' + personMobileNo
      if (person != null) {
        url = that.requestUrl + '/auth/person/info/activation/code/apply/add?fromDevice=h5&personId=' + person.personAccountInfoId + '&personToken=' + person.personAccountToken + '&loginTimestamp=' + person.personLoginTimeStamp + '&personOpenId=' + person.personAccountInfoDsfOpenId + '&personName=' + personName + '&personMobileNo=' + personMobileNo
      }
      that.$api.post(url, {}).then(res => {
        if (res.resultCode === 200) {
          this.$util.showSuccessMsg('申请提交成功，请等工作人员进行核实')
          that.showModal = false
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.page {
    background: #fff;
}
.bgC-F98E70 {
    background: #f98e70;
}
.u-info {
    height: 324px;
    padding: 112px 0 0 0;
    text-align: center;
    box-sizing: border-box;
}

.u-info .bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 274px;
}
.user-info {
    width: 100%;
}
.userName {
    /* margin: 22px 0 10px 0; */
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(41, 43, 50, 1);
}

.fc-686D74 {
    width: 36%;
    margin: 20px 0 0 0;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(104, 109, 116, 1);
}

.level {
    z-index: 90;
    position: absolute;
    right: 54px;
    top: 10px;
    width: 148px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background: rgba(254, 204, 0, 1);
    border-radius: 28px;
}
.kqb-card {
    width: 736px;
    height: 219px;
    margin: 0 auto;
    padding: 45px 0 0 206px;
    /*    background:rgba(255,255,255,1);
    box-shadow:0px 1px 13px 0px rgba(24,100,254,0.3);
    border-radius:6px; */
    box-sizing: border-box;
}
.kqb-Avatar {
    z-index: 20;
    position: absolute;
    top: -30px;
    left: 54px;
    max-width: 128px;
    min-width: 128px;
    width: 128px;
    height: 128px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.65);
    border: 1px solid #fff;
    border-radius: 200px;
    overflow: hidden;
}

.kqb-Avatar image {
    max-width: inherit;
    min-width: inherit;
    width: inherit;
    height: inherit;
    margin: 0px;
    border-radius: 50%;
}

.kqb-list {
    margin: 15px 0 0 0;
}

.kqb-list-item {
    justify-content: initial;
    height: 113px;
    padding: 0 60px;
}
.kqb-list-item .kqb-list-item-icon {
    margin-right: 30px;
}
.kqb-list-item:after {
    top: initial;
    bottom: 0;
    border-bottom: 1px solid rgba(246, 245, 248, 1);
    transform: scaleY(0.5);
    transform-origin: 0 0;
}

.kqb-list-item div {
    font-size: 30px;
    font-family: MicrosoftYaHeiLight;
    font-weight: 400;
    color: rgba(38, 25, 0, 1);
}
.kqb-list-item div.fc-8F8F8F {
    margin: 13px 0 0 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(143, 143, 143, 1);
}

.kqb-modal {
    z-index: 21;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
}

.kqb-modal-content {
    width: 580px;
    height: 660px;
    margin: 46% auto 0 auto;
    background: rgba(255, 255, 255, 1);
    border-radius: 10px;
}

.modal-head-bg {
    width: 100%;
    height: 295px;
}

.kqb-modal-content .kqb-form-list {
    margin: 14px 0 0 0;
    padding: 0 36px;
}

.kqb-modal-content .kqb-form-list input {
    width: 100%;
    height: 79px;
    line-height: 79px;
    margin: 30px 0 0 0;
    padding: 0 29px;
    font-size: 28px;
    background: rgba(234, 234, 234, 1);
    border-radius: 10px;
    border: 0;
    box-sizing: border-box;
}

.kqb-modal-content .kqb-btn {
    width: 100%;
    height: 79px;
    line-height: 79px;
    margin: 38px 0 0 0;
    padding: 0;
    font-size: 32px;
    font-weight: 400;
    color: rgba(254, 254, 254, 1);
    border-radius: 40px;
    border: 0;
}

.kqb-modal-content .modal-close {
    /* position: absolute;
    bottom: -111px; */
    /* left: 50%; */
    width: 67px;
    height: 67px;
    margin: 111px auto 0 auto;
    /* transform: translate(-50%, 0); */
}

.userCardBG {
    background: url("data:image/png;base64,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")
        no-repeat;
    background-size: 100% 100%;
}
</style>
